import { createFileRoute } from "@tanstack/react-router"
import { ComparisonLayout } from "@/routes/comparison"

export const Route = createFileRoute("/$lang/comparison")({
  component: ComparisonLayout,
})
